import type { PROFILE_EDIT_FORM_FIELDS } from './constants';

export interface ProfilePublicData {
  id: number;
  name: string;
  avatar: string;
  about?: string;
  lastGameId: number;
  isDeleted: boolean;
  isDeactivated: boolean;
}

export enum RegistrationStatus {
  Undefined = 0,
  Full = 1,
  LightForm = 5,
  SocialNetworkWithoutEmail = 10,
  SocialNetworkWithEmail = 11,
  NoPassword = 12,
  Guest = 20,
}

export interface ProfilePrivateData extends Omit<ProfilePublicData, 'lastGameId'> {
  country?: string;
  registrationStatus: RegistrationStatus;
  isApproved: boolean;
  isLockedChangeName: boolean;
  userGames?: Array<number>;
}

export enum ProfileTabs {
  Overview = 'overview',
  MyLibrary = 'my-library',
  Friends = 'friends',
}

export interface ProfileEditFormValues {
  [PROFILE_EDIT_FORM_FIELDS.NICKNAME]: string;
  [PROFILE_EDIT_FORM_FIELDS.ABOUT]: string;
}
